import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';
import { routes } from '../../routes';

const i18Path = 'documents2.corporateMoved';

export const CorporateDocumentsMoved: React.FC = () => {
  const t = useNamespacedTranslation(i18Path);

  return (
    <Card className="border-start border-4 border-secondary bg-light">
      <Card.Body>
        <Card.Title>{t('title')}</Card.Title>
        <p className="mb-2">{t('description')}</p>
        <Link to={routes.peopleDocuments.route.create({})}>
          {t('linkText')}
        </Link>
      </Card.Body>
    </Card>
  );
};
